import axios from 'axios';
import store from '@/store';

axios.defaults.withCredentials = false;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
        if (error) {
            promise.reject(error);
        } else {
            promise.resolve(token);
        }
    });

    failedQueue = [];
};

axios.interceptors.response.use(
    (response) => {
        return response;
    },

    async (error) => {
        console.log('AXIOS INTERCEPTOR:', error.response?.status);

        const originalRequest = error.config;

        // Not 401
        if (error.response?.status !== 401) {
            return Promise.reject(error);
        }

        // Refresh API itself failed
        if (originalRequest.url?.includes('/Auth/refresh')) {
            return Promise.reject(error);
        }

         if (originalRequest.url?.includes('/Auth/Login')) {
            return Promise.reject(error);
        }


        // Already retried
        if (originalRequest._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        // Another request is already refreshing
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({
                    resolve,
                    reject,
                });
            }).then((token) => {
                originalRequest.headers.Authorization = `Bearer ${token}`;

                return axios(originalRequest);
            });
        }

        isRefreshing = true;

        try {
            console.log('Refreshing token...');

            const response = await axios.post(
                `${store.getters.url}/Auth/refresh`,
                {},
                {
                    withCredentials: true,
                }
            );

            const newToken = response.data.data.accessToken;

            console.log('NEW TOKEN:', newToken);

            sessionStorage.setItem('token', newToken);

            // Update default token
            axios.defaults.headers.common.Authorization =
                `Bearer ${newToken}`;

            // Update queued requests
            processQueue(null, newToken);

            // Update failed request
            originalRequest.headers.Authorization =
                `Bearer ${newToken}`;

            isRefreshing = false;

            console.log('Retrying original request...');

            // 🔥 Retry original request
            return axios(originalRequest);

        } catch (refreshError) {
            console.log('REFRESH FAILED:', refreshError);

            processQueue(refreshError);

            isRefreshing = false;

            store.commit('logOutHandler');

            return Promise.reject(refreshError);
        }
    }
);

export default axios;